import {
    alertError,
    alertLoadError,
    alertNotAuthorized,
    alertRequestError,
    alertServerError,
    alertValidationResult,
    AlertActionType
} from '../../store/reducers/Alert';
import { constantMessage } from '../constants';
import { RequestRejectedError } from '../uploadRequestRejection';
import { getProjectMutationConflictMessage } from '../projectMutationConflict';

function extractForbiddenMessage(data: unknown): string | undefined {
    if (data == null) {
        return undefined;
    }
    if (typeof data === 'string') {
        const trimmed = data.trim();
        if (!trimmed) {
            return undefined;
        }
        try {
            return extractForbiddenMessage(JSON.parse(trimmed));
        } catch {
            return trimmed;
        }
    }
    if (typeof data === 'object') {
        const record = data as Record<string, unknown>;
        for (const key of ['detail', 'title', 'Message', 'message']) {
            const value = record[key];
            if (typeof value === 'string' && value.trim()) {
                return value.trim();
            }
        }
    }
    return undefined;
}

function isBlockedUserForbidden(error: { config?: { url?: string } }): boolean {
    const url = error.config?.url ?? '';
    return /GetCurrentUserContext/i.test(url);
}

const reportedRejections = new WeakSet<RequestRejectedError>();

export function handleError(error: any, dispatch: React.Dispatch<any>) {
    if (error instanceof RequestRejectedError) {
        if (!reportedRejections.has(error)) {
            reportedRejections.add(error);
            dispatch({
                type: AlertActionType.error,
                messages: [{ summary: 'Ошибка', detail: error.message, supportId: error.supportId, sticky: true }],
            });
        }
        return;
    }
    const conflict = getProjectMutationConflictMessage(error);
    if (conflict) {
        dispatch(alertError({ detail: conflict, sticky: true }));
        return;
    }

    if (error.response) {
        switch (error.response.status) {
            case 500:
                dispatch(alertServerError(error.response.data?.Message));
                break;
            case 400:
                const errData = error.response.data;
                if (errData !== null && typeof errData === 'object') {
                    if ('Errors' in errData) dispatch(alertValidationResult({ ...errData }));
                    else {
                        dispatch(alertError({ detail: errData?.title }));
                    }
                } else {
                    dispatch(alertError({ detail: errData }));
                }
                break;
            case 401:
                dispatch(alertNotAuthorized(error.response.statusText));
                // window.location.href = PathUtil.getAuthUrl(true);
                break;
            case 403:
                if (isBlockedUserForbidden(error)) {
                    window.location.href = '/blocked';
                } else {
                    dispatch(alertError({
                        detail: extractForbiddenMessage(error.response.data)
                            ?? constantMessage.noPermissionMessage,
                    }));
                }
                break;
            default:
                dispatch(alertLoadError(error));
                break;
        }
    } else if (error.request) {
        dispatch(alertRequestError());
    } else {
        if ('message' in error) {
            if (error.message === constantMessage.cancelRequest) {
                console.error(error + ``);
                return;
            }
        }
        dispatch(alertLoadError(error));
    }
}
